/*
 * DeleteAccountModal.module.css
 * All colors come from themes.css custom properties — no hardcoded values.
 */

.backdrop {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal {
  position: relative;
  background-color: var(--color-bg-card);
  color: var(--color-text-primary);
  border: 1px solid var(--color-border);
  border-radius: 8px;
  padding: 32px 28px 28px;
  max-width: 420px;
  width: 100%;
  margin: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.25);
}

/* ── Close button ─────────────────────────────────────────────────────────── */

.closeBtn {
  position: absolute;
  top: 10px;
  right: 14px;
  background: none;
  border: none;
  font-size: 1.5rem;
  line-height: 1;
  cursor: pointer;
  color: var(--color-text-muted);
  padding: 2px 6px;
}

.closeBtn:hover:not(:disabled) {
  color: var(--color-text-primary);
}

.closeBtn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* ── Content ──────────────────────────────────────────────────────────────── */

.title {
  font-size: 1.2rem;
  font-family: var(--font-family-base);
  color: var(--color-text-primary);
  margin: 0;
}

.warning {
  font-size: 0.9rem;
  color: var(--color-text-secondary);
  margin: 0;
  line-height: 1.5;
}

/* ── Typed confirmation ───────────────────────────────────────────────────── */

.confirmField {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.confirmLabel {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--color-text-secondary);
}

.confirmInput {
  background-color: var(--color-bg-secondary);
  color: var(--color-text-primary);
  border: 1px solid var(--color-border);
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 0.9rem;
  font-family: inherit;
  width: 100%;
  box-sizing: border-box;
}

.confirmInput:focus {
  outline: 2px solid var(--color-accent);
  outline-offset: 2px;
}

.confirmInput:disabled {
  opacity: 0.6;
}

/* ── Error message ────────────────────────────────────────────────────────── */

.errorMsg {
  font-size: 0.875rem;
  color: var(--color-accent);
  margin: 0;
}

/* ── Buttons ──────────────────────────────────────────────────────────────── */

.buttonRow {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.deleteConfirmBtn {
  background-color: var(--color-accent);
  color: var(--color-text-inverse);
  border: none;
  border-radius: 6px;
  padding: 9px 20px;
  font-size: 0.9rem;
  font-family: inherit;
  cursor: pointer;
  transition: background-color 0.2s;
  white-space: nowrap;
}

.deleteConfirmBtn:hover:not(:disabled) {
  background-color: var(--color-accent-hover);
}

.deleteConfirmBtn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.cancelBtn {
  background: none;
  color: var(--color-text-secondary);
  border: 1px solid var(--color-border);
  border-radius: 6px;
  padding: 9px 20px;
  font-size: 0.9rem;
  font-family: inherit;
  cursor: pointer;
  transition: border-color 0.15s, color 0.15s;
  white-space: nowrap;
}

.cancelBtn:hover:not(:disabled) {
  border-color: var(--color-text-secondary);
  color: var(--color-text-primary);
}

.cancelBtn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
